import { useMutation, useQueryClient, UseMutationOptions } from '@tanstack/react-query'
import { createApiCall } from 'services'
import { SIGNUPS_QUERY_KEY } from './useSignups'

export type RejectSignupPayload = {
  signupId: string
}

export type RejectSignupResponse = {
  id: string
  status: 'rejected'
  [key: string]: unknown
}

export const useRejectSignup = (
  options?: Omit<UseMutationOptions<RejectSignupResponse, Error, RejectSignupPayload>, 'mutationFn'>
) => {
  const queryClient = useQueryClient()

  return useMutation<RejectSignupResponse, Error, RejectSignupPayload>({
    mutationFn: async ({ signupId }) => {
      const response = await createApiCall({
        method: 'POST',
        url: `/internal/signups/${signupId}/reject`,
      })
      if (response.status >= 400) {
        throw new Error(response.data?.message || 'Failed to reject signup')
      }
      return response.data as RejectSignupResponse
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: [SIGNUPS_QUERY_KEY] })
      options?.onSuccess?.(data, variables, context)
    },
    onError: options?.onError,
    ...options,
  })
}
